import moment from 'moment'

export default async function editNode({ state, graphql }) {
  let { name, path, id, fromDate, toDate, tags } = state.get('node.panel')

  const groups = Object.keys(tags).reduce((acc, key) => {
    const tag = tags[key]
    if (tag.selected) {
      acc.push(`"${tag.label}"`)
    }
    return acc
  }, [])

  if (fromDate) {
    fromDate = moment(fromDate).valueOf()
  } else {
    fromDate = null
  }

  if (toDate) {
    toDate = moment(toDate)
      .endOf('day')
      .valueOf()
  } else {
    toDate = null
  }

  await graphql.mutate(`{
      editNode(id: "${id}", name: "${name.value}", fromDate: ${fromDate}, toDate: ${toDate}, groups: [${groups.join()}]) {
        id
      }
    }`)

  state.set(`${path}.name`, name.value)
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/editNode.js